<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<template>
  <evd-form
    v-on="$listeners"
    :checklist-item="checklistItem"
    :disabled="false"
    ref="evdForm"
  />
</template>

<script>
import EvdForm from "@/components/EvdForm";

export default {
  name: "EvdSignup",
  components: { EvdForm },
  props: {
    checklistItem: {
      required: true
    }
  },
  methods: {
    save() {
      return this.$refs.evdForm.save();
    },
    validate() {
      this.$refs.evdForm.validate();
    }
  }
};
</script>

<style scoped></style>
